<template>
    <section class="media_details_wrp">
        <div class="container">
            <!-- Loading indicator placeholder (toggle with loading state if needed) -->
            <div v-if="isLoading" class="httploader">
                <i class="fa fa-spinner fa-spin fa-3x"></i>
            </div>

            <div class="row" v-else-if="popularVideosData">
                <!-- Main Video Area -->
                <div class="col-md-8">
                    <div class="media_video_details">
                        <div class="video_wrapper">
                            <iframe v-if="mediaVideoId"
                                :src="`https://www.youtube.com/embed/${mediaVideoId}?autoplay=1`"
                                class="embed-responsive-item" allowfullscreen></iframe>
                        </div>

                        <div class="row mt-2" v-if="selectedVideo">
                            <div class="col-md-6">
                                <ul class="views_upload_wrp">
                                    <li>
                                        <span><i class="fa fa-calendar"></i>&nbsp;</span>
                                        <span>{{ selectedVideo.snippet.publishedAt | LocalDateFormat }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6 text-md-right"></div>
                        </div>

                        <div class="video_author_details" v-if="selectedVideo">
                            <h2 class="author_name">{{ selectedVideo.snippet.title }}</h2>
                            <div class="video_author_details_inner" v-html="selectedVideo.snippet.description"></div>
                            <video-comments :currentVideoData="selectedVideo"></video-comments>
                        </div>
                    </div>
                </div>

                <!-- Sidebar / Related Videos -->
                <div class="col-md-4 ml-auto">
                    <div class="related_video_wrp">
                        <h3 class="related_video_heading">Related Videos</h3>
                    </div>
                    <div class="related_video_slider">
                        <div class="media_slider" v-if="filteredRelatedVideos.length > 0">
                            <div class="video_details" v-for="related in filteredRelatedVideos" :key="related.id">
                                <router-link :to="{
                                    name: 'VistaMediaInfo',
                                    params: { videoID: related.snippet.resourceId.videoId }
                                }">
                                    <div class="video_thumb" :style="{
                                        backgroundImage: `url(${related.snippet.thumbnails.medium ? related.snippet.thumbnails.medium.url : related.snippet.thumbnails.default.url})`
                                    }"></div>
                                    <div class="playerinfo">
                                        <h3 class="player_name" :title="related.snippet.title">
                                            {{ related.snippet.title }}
                                        </h3>
                                        <div class="player_designation" v-html="related.snippet.description"></div>
                                        <div class="video_uploaded_date">
                                            <i class="fa fa-upload"></i> {{ related.snippet.publishedAt |
                                            LocalDateFormat }}
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import commentVideo from './comment-on-video-list';

export default {
    name: 'VistaMediaDetails',
    components: {
        'video-comments': commentVideo
    },
    data() {
        return {
            mediaVideoId: '',
            isLoading: false
        };
    },
    computed: {
        ...mapGetters({
            rawMediaData: 'getListVistaPublicOfVideoGetters'
        }),
        popularVideosData() {
            return this.rawMediaData ? this.rawMediaData.data : null;
        },
        popularVideosResults() {
            return this.popularVideosData && Array.isArray(this.popularVideosData.items)
                ? this.popularVideosData.items
                : [];
        },
        filteredRelatedVideos() {
            return this.popularVideosResults.filter((item) => {
                var snippet = item && item.snippet;
                var thumbnails = snippet && snippet.thumbnails;
                var resourceId = snippet && snippet.resourceId;

                return (
                    thumbnails &&
                    thumbnails.default != null &&
                    resourceId &&
                    resourceId.videoId !== this.mediaVideoId
                );
            });
        },

        selectedVideo() {
            if (!this.popularVideosResults.length || !this.mediaVideoId) return null;

            return (
                this.popularVideosResults.find((media) => {
                    return (
                        media &&
                        media.snippet &&
                        media.snippet.resourceId &&
                        media.snippet.resourceId.videoId === this.mediaVideoId
                    );
                }) || null
            );
        }
    },
    created() {
        this.mediaVideoId = this.$route.params.videoID;
        this.fetchMediaData();
    },
    watch: {
        '$route.params.videoID'(newId) {
            this.mediaVideoId = newId;
            // If store is empty, fetch; otherwise computed 'selectedVideo' updates reactively
            if (!this.popularVideosResults.length) {
                this.fetchMediaData();
            }
        }
    },
    methods: {
        async fetchMediaData() {
            // Prevent fetching if store already populated
            if (this.popularVideosResults.length > 0) return;

            this.isLoading = true;
            try {
                await this.$store.dispatch('getListVistaPublicOfVideoFun');
            } catch (err) {
                console.error('Failed to fetch videos:', err);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.media_details_wrp {
    min-height: 100dvh;
    letter-spacing: 1px;
    color: #fff;
    padding: 10px;

    >.container {
        min-height: calc(100dvh - 70px);
        max-width: 100%;
        padding: 15px 30px;
        background: rgba(0, 0, 0, 0.75);
    }

    .video_details {
        margin-top: 5px;
        width: 100%;
        background: linear-gradient(-30deg,
                rgba(37, 44, 84, 0.6) 0%,
                rgba(0, 0, 0, 0.6) 50%,
                rgba(38, 38, 38, 0.6) 50%,
                rgba(44, 44, 84, 0.6) 100%);
        border: 1px solid rgba(93, 93, 93, 0.4);
        float: left;
        padding: 0;

        a {
            text-decoration: none;
            display: block;
            padding: 8px;

            &:hover .player_name {
                color: #ffd400;
            }
        }
    }

    .video_wrapper {
        .embed-responsive-item {
            width: 100%;
            height: 380px;
            border: none;
            outline: none;
        }
    }

    .views_upload_wrp {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            display: inline-block;
            vertical-align: middle;
            margin-right: 20px;
            color: #747474;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 14px;

            &:last-child {
                margin-right: 0;
            }

            span .fa {
                margin-right: 2px;
            }
        }
    }

    .video_author_details {
        margin-top: 15px;

        .author_name {
            font-family: "BeonMedium", sans-serif;
            font-size: 24px;
            margin-bottom: 8px;
            color: #ffd400;
        }
    }

    .video_author_details_inner {
        font-family: 'georgiaregular';
        color: #d6d6d6;
        font-size: 15px;
        text-align: justify;
        line-height: 1.3;
    }

    .related_video_wrp {
        .related_video_heading {
            font-size: 24px;
            font-family: 'the_bold_fontbold';
            margin-bottom: 10px;
            line-height: 1;
            color: #fffcc4;
        }
    }

    .related_video_slider {
        .video_details .playerinfo {
            text-align: left;
            max-width: calc(100% - 170px);
            overflow: hidden;
            width: 100%;
        }

        .video_thumb {
            float: left;
            width: 100%;
            height: 80px;
            display: block;
            margin-right: 10px;
            max-width: 160px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
        }
    }

    .player_name {
        font-size: 18px;
        font-weight: 600;
        line-height: 1;
        margin: 0 0 5px;
        font-family: "BeonMedium", sans-serif;
        height: 19px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        color: #87cefa;
    }

    .player_designation {
        color: #d6d6d6;
        font-family: 'georgiaregular';
        line-height: 1.2;
        margin-bottom: 3px;
        height: 34px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        font-size: 14px;
    }

    .video_uploaded_date {
        color: #747474;
        font-size: 13px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
    }

    .media_slider {
        padding-bottom: 65px;
        display: table;
        width: 100%;
    }

    .httploader {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.72);
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>